import { render, staticRenderFns } from "./ModalRazao.vue?vue&type=template&id=b16b9456&scoped=true"
import script from "./ModalRazao.vue?vue&type=script&lang=js"
export * from "./ModalRazao.vue?vue&type=script&lang=js"
import style0 from "./ModalRazao.vue?vue&type=style&index=0&id=b16b9456&prod&lang=scss&scoped=true"
import style1 from "./ModalRazao.vue?vue&type=style&index=1&id=b16b9456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16b9456",
  null
  
)

export default component.exports